// import { useState, useEffect } from "react";

// function useWindowSize() {
//   const [windowSize, setWindowSize] = useState({
//     width: window.innerWidth,
//     height: window.innerHeight,
//   });

//   useEffect(() => {
//     const handleResize = () => {
//       setWindowSize({
//         width: window.innerWidth,
//         height: window.innerHeight,
//       });
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return windowSize;
// }

// export default useWindowSize;



import { useState, useEffect } from "react";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    size: getScreenSize(window.innerWidth), 
  });

  
  function getScreenSize(width) {
    if (width < 576) {
      return "xsm";
    } else if (width >= 576 && width < 768) {
      return "sm"; 
    } else if (width >= 768 && width < 992) {
      return "md"; 
    } else if (width >= 992 && width < 1200) {
      return "lg"; 
    } else if (width >= 1200 && width < 1400) {
      return "xl"; 
    } else {
      return "xxl"; 
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        screenSize: getScreenSize(window.innerWidth), // actualiza el tamaño
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
}

export default useWindowSize;

